import React from 'react';
import TaskColumn from './TaskColumn';

const GoalsColumn = ({
  goals,
  selectedGoal,
  setSelectedGoal,
  setSelectedStep,
  setSelectedTask,
  newGoalText,
  setNewGoalText,
  addGoal,
  setGoals,
  columnHeaders,
  setColumnHeaders,
  openMenuId,
  setOpenMenuId,
  openSubmenuId,
  setOpenSubmenuId,
  filterState,
  editingItemId,
  setEditingItemId,
  editingText,
  setEditingText,
  draggedItem,
  handleDragStart,
  handleDragOver,
  handleDrop
}) => {
  const toggleGoalCompletion = (goalId) => {
    const updatedGoals = goals.map((goal) =>
      goal.id === goalId ? { ...goal, completed: !goal.completed } : goal
    );
    setGoals(updatedGoals);
  };

  const deleteGoal = (goalId) => {
    const updatedGoals = goals.filter((goal) => goal.id !== goalId);
    setGoals(updatedGoals);
    if (selectedGoal === goalId) {
      setSelectedGoal(null);
      setSelectedStep(null);
      setSelectedTask(null);
    }
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };

  const setGoalPriority = (goalId, priority) => {
    const updatedGoals = goals.map((goal) =>
      goal.id === goalId ? { ...goal, priority: priority } : goal
    );
    setGoals(updatedGoals);
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };

  const updateGoalTitle = (goalId, newTitle) => {
    const updatedGoals = goals.map(g => 
      g.id === goalId ? {...g, title: newTitle} : g
    );
    setGoals(updatedGoals);
    setEditingItemId(null);
  };

  return (
    <TaskColumn
      type="goal"
      items={goals}
      selectedId={selectedGoal}
      setSelectedId={setSelectedGoal}
      newItemText={newGoalText}
      setNewItemText={setNewGoalText}
      addItem={addGoal}
      toggleCompletion={toggleGoalCompletion}
      columnHeaders={columnHeaders}
      setColumnHeaders={setColumnHeaders}
      headerKey="goals"
      openMenuId={openMenuId}
      setOpenMenuId={setOpenMenuId}
      openSubmenuId={openSubmenuId}
      setOpenSubmenuId={setOpenSubmenuId}
      deleteItem={deleteGoal}
      setPriority={setGoalPriority}
      filterState={filterState}
      editingItemId={editingItemId}
      setEditingItemId={setEditingItemId}
      editingText={editingText}
      setEditingText={setEditingText}
      updateItemTitle={updateGoalTitle}
      draggedItem={draggedItem}
      handleDragStart={handleDragStart}
      handleDragOver={handleDragOver}
      handleDrop={handleDrop}
    />
  );
};

export default GoalsColumn; 